import { TrustPoints } from "../../types/service";
import FinishCard from "./FinishCard";


interface Props {
  sideCardtitle?: string;
  trustPoints?: TrustPoints[];
}
const SideCard: React.FC<Props> = ({ trustPoints, sideCardtitle }) => {
  return (
    <>
      <div className="p-3 bg-2 rounded m-b-32">
        <p className="font-14 ff-bold text-black">Get Help</p>
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2 cart-call">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/phone-icon.svg"
              alt=""
            />
            <a
              href="tel:+97142979997"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <p className="mb-0 ff-medium font-12 text-primary">Call</p>
            </a>
          </div>
          <div className="d-flex align-items-center gap-2 cart-whatsap">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/whatsap-cart.svg"
              alt=""
            />
            <a
              href="https://web.whatsapp.com/send?phone=97142979998"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <p className="mb-0 ff-medium font-12">WhatsApp</p>
            </a>
          </div>
        </div>
      </div>
      <FinishCard />
      <div className="p-3 layout-border  rounded">
        <p className="font-14 ff-bold text-black mb-3 border-bottom pb-2">
          {sideCardtitle}
        </p>
        <ul className="list-unstyled">
          {trustPoints && trustPoints.map((point, idx) => (
            <li key={idx} className="d-flex align-items-start mb-2 cart-slots-main mb-4">
              <img src={point.IconUrl} alt={point.TrustTitle} width="20" className="me-2" />
              <div>
                <p className="ff-semibold font-13 text-black mb-0">{point.TrustTitle}</p>
                <p className="ff-medium font-12 text-grey mb-0">{point.TrustDescription}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SideCard;
